module.exports = __webpack_public_path__ + "img/side-img.57fd1a2d.png";